export class OpenSignerViewRequest {
  loanDocTaskId: number;
  returnUrl: string
  applicationId: number;
  leadId: number;
  borrowerId: number;
}
